<template>
  <div class="mainbody">
    <!-- <img src="@/assets/index1.png" alt="" class="bg" /> -->
    <div class="mainbody_content">
      <div class="title">订单管理</div>

      <div class="list">
        <div class="list_item">
          <div
            class="list_item_title flex flex-ac text-2c2c2c text-14 text-600"
          >
            订单信息
          </div>
          <div class="flex flex-ac flex-jsb list_item_descriptions">
            <div class="descriptions">
              <div class="flex descriptions_item">
                <div class="text-666 text-14 descriptions_label">订单编号</div>
                <div class="text-2c2c2c text-14 text-600 descriptions_value">
                  {{ info.number }}
                </div>
              </div>
              <div class="flex descriptions_item">
                <div class="text-666 text-14 descriptions_label">
                  笔记（备注）
                </div>
                <div class="text-2c2c2c text-14 text-600 descriptions_value">
                  {{ info.note }}
                </div>
              </div>
              <div class="flex descriptions_item">
                <div class="text-666 text-14 descriptions_label">订单状态</div>
                <div class="text-2c2c2c text-14 text-600 descriptions_value">
                  {{ info.financial_status_show }}
                </div>
              </div>
              <div class="flex descriptions_item">
                <div class="text-666 text-14 descriptions_label">物流状态</div>
                <div class="text-2c2c2c text-14 text-600 descriptions_value">
                  发往香港途中
                </div>
              </div>
              <div class="flex descriptions_item">
                <div class="text-666 text-14 descriptions_label">订单时间</div>
                <div class="text-2c2c2c text-14 text-600 descriptions_value">
                  {{ info.order_created_at }}
                </div>
              </div>
            </div>
            <!-- <div class="">
              <button class="list_item_btn1 xyac">订单详情</button>
              <button class="list_item_btn2 xyac">申请退款</button>
            </div> -->
          </div>
        </div>

        <div class="list_item">
          <div
            class="list_item_title flex flex-ac text-2c2c2c text-14 text-600"
          >
            付款信息
          </div>
          <div class="flex flex-ac flex-jsb list_item_descriptions">
            <div class="descriptions">
              <div class="flex descriptions_item">
                <div class="text-666 text-14 descriptions_label">付款方式</div>
                <div class="text-2c2c2c text-14 text-600 descriptions_value">
                  {{ info.payment_method }}
                </div>
              </div>
              <div class="flex descriptions_item">
                <div class="text-666 text-14 descriptions_label">总税额</div>
                <div class="text-2c2c2c text-14 text-600 descriptions_value">
                  ${{ info.total_tax }}
                </div>
              </div>
              <div class="flex descriptions_item">
                <div class="text-666 text-14 descriptions_label">货币</div>
                <div class="text-2c2c2c text-14 text-600 descriptions_value">
                  {{ info.currency }}
                </div>
              </div>
              <div class="flex descriptions_item">
                <div class="text-666 text-14 descriptions_label">总运费</div>
                <div class="text-2c2c2c text-14 text-600 descriptions_value">
                  ${{ info.total_shipping }}
                </div>
              </div>
              <div class="flex descriptions_item">
                <div class="text-666 text-14 descriptions_label">总价</div>
                <div class="text-2c2c2c text-14 text-600 descriptions_value">
                  ${{ info.total_price }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="list_item">
          <div
            class="list_item_title flex flex-ac text-2c2c2c text-14 text-600"
          >
            客户信息
          </div>
          <div class="flex flex-ac flex-jsb list_item_descriptions">
            <div class="descriptions">
              <div class="flex descriptions_item">
                <div class="text-666 text-14 descriptions_label">客户姓氏</div>
                <div class="text-2c2c2c text-14 text-600 descriptions_value">
                  {{ info.shipping_address?.first_name || '-' }}
                </div>
              </div>
              <div class="flex descriptions_item">
                <div class="text-666 text-14 descriptions_label">收件地址</div>
                <div class="text-2c2c2c text-14 text-600 descriptions_value">
                  {{ info.address1 }}
                </div>
              </div>
              <div class="flex descriptions_item">
                <div class="text-666 text-14 descriptions_label">客户名称</div>
                <div class="text-2c2c2c text-14 text-600 descriptions_value">
                  {{ info.shipping_address?.last_name || '-' }}
                </div>
              </div>
              <!-- <div class="flex descriptions_item">
                <div class="text-666 text-14 descriptions_label">客户备注</div>
                <div class="text-2c2c2c text-14 text-600 descriptions_value">
                  备注备注备注备注备注备注
                </div>
              </div> -->
              <div class="flex descriptions_item">
                <div class="text-666 text-14 descriptions_label">电话号码</div>
                <div class="text-2c2c2c text-14 text-600 descriptions_value">
                  {{ info.order_customer?.phone || '-' }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="list_item">
          <div
            class="list_item_title flex flex-ac text-2c2c2c text-14 text-600"
          >
            退款信息
          </div>
          <div class="flex flex-ac flex-jsb list_item_descriptions">
            <div class="descriptions">
              <div class="flex descriptions_item">
                <div class="text-666 text-14 descriptions_label">退款原因</div>
                <div class="text-2c2c2c text-14 text-600 descriptions_value">
                  备注备注备注备注备注备注
                </div>
              </div>
              <div class="flex descriptions_item">
                <div class="text-666 text-14 descriptions_label"></div>
                <div
                  class="text-2c2c2c text-14 text-600 descriptions_value"
                ></div>
              </div>
              <div class="flex descriptions_item">
                <div class="text-666 text-14 descriptions_label">申请时间</div>
                <div class="text-2c2c2c text-14 text-600 descriptions_value">
                  2025-04-01 21:13:28
                </div>
              </div>
              <div class="flex descriptions_item">
                <div class="text-666 text-14 descriptions_label"></div>
                <div
                  class="text-2c2c2c text-14 text-600 descriptions_value"
                ></div>
              </div>
              <div class="flex descriptions_item">
                <div class="text-666 text-14 descriptions_label">退款状态</div>
                <div class="text-2c2c2c text-14 text-600 descriptions_value">
                  待受理
                </div>
              </div>
            </div>
            <div class="">
              <button class="list_item_btn1 xyac" @click="$router.back()">
                返回
              </button>
            </div>
          </div>
        </div> -->
        <el-button type="primary" @click="$router.back()">返回</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import request from '@/utils/request'
export default {
  data() {
    return {
      order_number: '',
      info: {},
    }
  },
  mounted() {
    console.log(this.$route)
    if (this.$route.query.order_number) {
      this.order_number = this.$route.query.order_number
      this.getdetail()
    }
  },
  methods: {
    getdetail() {
      request({
        url: '/api/backend/order/detail',
        method: 'get',
        params: {
          order_number: this.order_number,
        },
      }).then((res) => {
        if (res.code == 0) {
          this.info = res.data
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.mt_1_25rem {
  margin-top: 1.25rem;
}
.bg {
  position: absolute;
  z-index: -1;
  left: 0;
  top: 0;
  height: 10.38rem;
  object-fit: cover;
}
.mainbody {
  overflow: hidden;
  position: relative;
  z-index: 1;
  .title {
    font-weight: 600;
    font-size: 1.63rem;
    color: #2c2c2c;
    line-height: 2.31rem;
    margin-bottom: 1.56rem;
  }
  &_content {
    box-sizing: border-box;
    overflow: hidden;
    margin: 2.5rem;
    padding: 2.5rem;
    width: 68.94rem;
    max-height: 85.75rem;
    background: #ffffff;
    border-radius: 0.5rem;
  }
}
.fliter {
  width: 5.63rem;
  height: 2.63rem;
  background: #b4926e;
  border-radius: 0.5rem;
  margin-left: 0.88rem;
  font-size: 0.88rem;
  color: #ffffff;
}
::v-deep .el-input__inner {
  height: 2.63rem;
  width: 10rem;
  border-radius: 0.5rem;
}
::v-deep .el-input__inner:focus {
  border-color: #b4926e !important;
}
::v-deep .el-select {
  margin-left: 0.63rem;
  margin-right: 1.25rem;
}
::v-deep .el-date-editor .el-range__icon {
  font-size: 0.88rem;
}
::v-deep .el-range-editor.is-active:hover {
  border-color: #b4926e !important;
}
::v-deep .el-range-editor.is-active {
  border-color: #b4926e !important;
}
::v-deep .el-date-editor {
  width: 16rem;
  margin-left: 0.63rem;
  margin-right: 1.25rem;
}
::v-deep .is-focus > .el-input__inner {
  border-color: #b4926e !important;
}
.list {
  margin-top: 2.69rem;
  &_item:last-child {
    margin-bottom: 0;
  }
  &_item {
    margin-bottom: 1.25rem;
    width: 63.75rem;
    // height: 16.19rem;
    border-radius: 0.5rem;
    border: 0.06rem solid #e4e6ea;
    &_title {
      box-sizing: border-box;
      padding: 0 0.94rem;
      // width: 63.94rem;
      height: 2.88rem;
      background: #f3f4f7;
      border-radius: 0.5rem 0.5rem 0rem 0rem;
    }
    &_descriptions {
      padding: 1.25rem;
    }
    &_btn1 {
      width: 11.31rem;
      height: 2.88rem;
      background: #b4926e;
      border-radius: 0.25rem;
      font-size: 1rem;
      color: #ffffff;
      margin-bottom: 1.25rem;
    }
    &_btn2 {
      width: 11.31rem;
      height: 2.88rem;
      border-radius: 0.25rem;
      border: 0.06rem solid #b4926e;
      font-size: 1rem;
      color: #b4926e;
    }
  }
}
.descriptions {
  display: grid;
  grid-template-columns: repeat(2, 20rem);
  &_item {
    margin-bottom: 1.25rem;
  }
  &_item:last-child {
    margin-bottom: 0;
  }
  &_label {
    white-space: nowrap;
    min-width: 3.75rem;
    margin-right: 0.94rem;
  }
  &_value {
    width: 15.25rem;
  }
}
.pagination {
  margin-top: 2.06rem;
}
::v-deep .el-pager li.active {
  width: 1.75rem;
  height: 1.75rem;
  color: #ffffff;
  line-height: 1.75rem;
  background: #b4926e;
  border-radius: 50%;
}
::v-deep .number {
  width: 1.75rem;
  margin-right: 0.63rem;
  height: 1.75rem !important;
  line-height: 1.75rem !important;
}
::v-deep .number:last-child {
  margin-right: 0;
}
::v-deep .number:hover {
  color: #b4926e;
}
::v-deep .btn-prev {
  width: 1.75rem;
  height: 1.75rem !important;
  line-height: 1.75rem !important;
}
::v-deep .btn-prev:hover {
  color: #b4926e;
}
::v-deep .btn-next {
  width: 1.75rem;
  height: 1.75rem !important;
  line-height: 1.75rem !important;
}
::v-deep .btn-next:hover {
  color: #b4926e;
}
</style>
